import {
  Box,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from '@mui/material';
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Routes } from '../CSIRouter.tsx';
import { Breadcrumb } from './CrumbContext.tsx';
import { useCrumb } from './useCrumb.ts';

interface BreadcrumbTrailProps {
  mobile?: boolean;
  crumb?: Breadcrumb;
}

export const BreadcrumbTrail: React.FC<BreadcrumbTrailProps> = ({
  mobile = false,
  crumb = { path: `/${Routes.Root.FiscalYears.path}`, label: 'Fiscal Years' },
}) => {
  const location = useLocation();
  const { crumbs, addCrumb } = useCrumb();
  addCrumb(crumb, location.pathname);
  if (mobile) {
    return (
      <List>
        {(crumbs ?? []).map((item: Breadcrumb) => (
          <ListItem key={item.path} disablePadding>
            <ListItemButton
              component={NavLink}
              to={item.path}
              selected={location.pathname === item.path}
            >
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    );
  }

  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      {(crumbs ?? []).map((item: Breadcrumb, index: number) => {
        const isActive = location.pathname.startsWith(item.path);
        const isLast = index === crumbs.length - 1;

        return (
          <React.Fragment key={item.path}>
            <Button
              key={item.path}
              component={NavLink}
              to={item.path}
              sx={{
                px: 3,
                py: 1,
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 500,
                fontSize: '0.95rem',
                color: isActive ? '#FFFFFF' : '#FFFFFF',
                backgroundColor: isActive ? '#046156' : 'transparent',
                position: 'relative',
                transition: 'all 0.2s ease',
                '&:hover': {
                  color: '#FFFFFF',
                  transform: 'translateY(-1px)',
                  backgroundColor: isActive
                    ? '#046156 !important'
                    : 'transparent !important',
                },
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  bottom: 0,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: isActive ? '60%' : '0%',
                  height: '2px',
                  borderRadius: '3px 3px 0 0',
                  transition: 'width 0.2s ease',
                },
                '&:hover::after': {
                  width: '60%',
                  backgroundColor: 'secondary.main',
                  transition: 'all 0.2s ease',
                },
              }}
            >
              {item.label}
            </Button>
            {!isLast && (
              <Box
                component='span'
                sx={{
                  color: '#FFFFFF',
                  px: 0.2,
                  display: 'inline-flex',
                  alignItems: 'center',
                }}
              >
                &gt;
              </Box>
            )}
          </React.Fragment>
        );
      })}
    </Box>
  );
};
